import { useEffect, useState } from "react";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  ReferenceField,
  TextField,
  useNotify,
  useRecordContext,
} from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";
import dataProvider from "server/dataProvider";
import { getFile } from "server/components/DownloadFile";

const PreferencesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();
  const notify = useNotify();

  const [preferenceDocumentTypes, setPreferenceDocumentTypes] = useState(null);

  const preferenceDocuments = record?.preferenceDocuments;

  useEffect(() => {
    if (!preferenceDocuments?.length) return;

    const fetchPreferenceDocumentTypes = async () => {
      try {
        const { data } = await dataProvider.customRequest(administrationRequests.getPreferenceDocumentTypesSelect());
        setPreferenceDocumentTypes(data);
      } catch (err) {
        console.error("Неуспешно зареждане на типовете документи", err);
        setPreferenceDocumentTypes([]);
      }
    };

    fetchPreferenceDocumentTypes();
  }, [preferenceDocuments]);

  if (!record?.preferenceData?.length) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Избрани преференции"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField
            source="preferenceData"
            label="Избрани преференции"
          >
            <Datagrid
              bulkActionButtons={false}
              size="small"
              rowClick={false}
              sx={settings.style.detailsDatagrid}
            >
              <ReferenceField
                source="preferenceId"
                reference={administrationRequests.getPreferencesSelect()}
                label="Преференция"
                sortable={false}
              >
                <TextField source="nameBg" />
              </ReferenceField>
              <FunctionField
                label="Допълнителни данни"
                render={preference => (preference?.key ? `${preference.key}: ${preference.value}` : "-")}
              />
              <FunctionField
                label="Тип документ"
                render={preference =>
                  record.preferenceDocuments
                    ?.filter(document => document.preferenceId === preference.preferenceId)
                    .map((document, index) => (
                      <Typography
                        sx={{ fontSize: "14px" }}
                        key={index}
                      >
                        {preferenceDocumentTypes?.find(type => type.id === document.documentTypeId)?.name}
                      </Typography>
                    ))
                }
              />
              <FunctionField
                label="Свали документ"
                render={preference =>
                  record.preferenceDocuments
                    ?.filter(document => document.preferenceId === preference.preferenceId)
                    .map((document, index) => (
                      <Typography
                        key={index}
                        sx={{ textDecoration: "underline", fontSize: "14px", cursor: "pointer" }}
                        onClick={() => getFile(document.documentId, notify, "private")}
                      >{`file-${document.documentId}.pdf`}</Typography>
                    ))
                }
              />
            </Datagrid>
          </ArrayField>
        </Grid>
      </Grid>
    </>
  );
};

export default PreferencesSection;
